export const isNotFalse = <T>(element: T | false | undefined | null): element is T => Boolean(element)
export const arrayUnique = <T>(array: T[]): T[] => Array.from(new Set(array))
